import { api } from '@/client/utils'

export const updateSampleBookOrder = async (data) => {
  const url = `/sample-book/create`
  return await api.post(url, JSON.stringify(data))
}
